import { Box, Typography, Stack, Chip } from '@mui/material';

function TagEditor({ label, values, onChange, options, disabled = false }) {
  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        {label}
      </Typography>
      <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap' }}>
        {options.map((option) => (
          <Chip
            key={option}
            label={option}
            clickable={!disabled}
            disabled={disabled}
            color={values.includes(option) ? 'primary' : 'default'}
            variant={values.includes(option) ? 'filled' : 'outlined'}
            onClick={() => onChange(values.includes(option) ? values.filter((value) => value !== option) : [...values, option])}
          />
        ))}
      </Stack>
    </Box>
  );
}

export default TagEditor;
